var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const _ErrorInfoServiceInstance = class _ErrorInfoServiceInstance {
  /**
   * Modifies an error message based on the provided error code or by applying regex patterns
   * @param code - The error code used to identify the type of error
   * @param errorMessage - The original error message to be modified
   * @returns The modified error message
   */
  modifyErrorMessage(code, errorMessage) {
    if (!errorMessage) {
      return errorMessage;
    }
    if (code && !/^[1-5][0-9][0-9]$/.test(code)) {
      return this.modifyByErrorCode(code, errorMessage);
    }
    return this.modifyByRegexPatterns(errorMessage);
  }
  /**
   * Modifies the error message based on specific error codes.  Error codes are defined in the following files:
   * https://dev.azure.com/experimentation/Analysis%20and%20Experimentation/_git/AnE.ExP.API?path=/src/ExP.API.Contract.Web/ApiObjects/ApiErrorCodes.cs
   * https://dev.azure.com/experimentation/Analysis%20and%20Experimentation/_git/AnE.ExP.Nuget?path=/AnE.ExP.Core.HttpClientUtil/src/AnE.ExP.Core.HttpClientUtil/Contract/ErrorHandling/ApiErrorCodes.cs
   * @param code - The error code
   * @param errorMessage - The original error message
   * @returns The modified error message
   */
  modifyByErrorCode(code, errorMessage) {
    const { ERROR_CODES, ERROR_MESSAGES, ERROR_PREFIXES } = _ErrorInfoServiceInstance;
    switch (code) {
      case ERROR_CODES.EXPERIMENT_TEMPLATE_NOT_IN_SNAPSHOT:
      case ERROR_CODES.NO_EXPERIMENT_TEMPLATES_IN_SNAPSHOT:
        return `${errorMessage}.  ${ERROR_MESSAGES.PROGRESSION_MODIFICATION}  ${ERROR_MESSAGES.SELECT_TEMPLATE_AND_SNAPSHOT}`;
      case ERROR_CODES.PROGRESSION_TEMPLATE_NOT_IN_SNAPSHOT:
      case ERROR_CODES.NO_PROGRESSION_TEMPLATES_IN_SNAPSHOT:
        return `${errorMessage}. ${ERROR_MESSAGES.PROGRESSION_MODIFICATION}  ${ERROR_MESSAGES.SELECT_PROGRESSION_TEMPLATE_AND_SNAPSHOT}`;
      case ERROR_CODES.SNAPSHOT_NOT_FOUND_IN_EXPERIMENT_TEMPLATES:
      case ERROR_CODES.SNAPSHOT_NOT_FOUND_IN_PROGRESSION_TEMPLATES:
        return `${errorMessage}. ${ERROR_MESSAGES.PROGRESSION_MODIFICATION}  ${ERROR_MESSAGES.SELECT_EXISTING_SNAPSHOT}`;
      default:
        return `${ERROR_PREFIXES.GENERAL} (${code}): ${errorMessage}`;
    }
  }
  /**
   * Modifies the error message by applying regex patterns
   * @param errorMessage - The original error message
   * @returns The modified error message
   */
  modifyByRegexPatterns(errorMessage) {
    const { REGEX_PATTERNS } = _ErrorInfoServiceInstance;
    if (REGEX_PATTERNS.ISOLATION_GROUP.test(errorMessage)) {
      const match = errorMessage.match(REGEX_PATTERNS.ISOLATION_GROUP);
      const isolationGroupErrorMessage = match ? match[0] : "";
      return `${isolationGroupErrorMessage}  ${_ErrorInfoServiceInstance.ERROR_MESSAGES.ISOLATION_GROUP_FIX}`;
    }
    if (REGEX_PATTERNS.AUTHENTICATION.test(errorMessage)) {
      return `${_ErrorInfoServiceInstance.ERROR_PREFIXES.AUTHENTICATION}: ${errorMessage}`;
    }
    if (REGEX_PATTERNS.NETWORK.test(errorMessage)) {
      return `${_ErrorInfoServiceInstance.ERROR_PREFIXES.NETWORK}: ${errorMessage}`;
    }
    if (REGEX_PATTERNS.VALIDATION.test(errorMessage)) {
      return `${_ErrorInfoServiceInstance.ERROR_PREFIXES.VALIDATION}: ${errorMessage}`;
    }
    if (REGEX_PATTERNS.SERVER.test(errorMessage)) {
      return `${_ErrorInfoServiceInstance.ERROR_PREFIXES.SERVER}: ${errorMessage}`;
    }
    if (REGEX_PATTERNS.TIMEOUT.test(errorMessage)) {
      return `${_ErrorInfoServiceInstance.ERROR_PREFIXES.TIMEOUT}: ${errorMessage}`;
    }
    if (REGEX_PATTERNS.NOT_FOUND.test(errorMessage)) {
      return `${_ErrorInfoServiceInstance.ERROR_PREFIXES.NOT_FOUND}: ${errorMessage}`;
    }
    return errorMessage;
  }
};
// Error code constants
__publicField(_ErrorInfoServiceInstance, "ERROR_CODES", {
  EXPERIMENT_TEMPLATE_NOT_IN_SNAPSHOT: "experimentTemplateNotInSnapshot",
  NO_EXPERIMENT_TEMPLATES_IN_SNAPSHOT: "noExperimentTemplatesInSnapshot",
  PROGRESSION_TEMPLATE_NOT_IN_SNAPSHOT: "progressionTemplateNotInSnapshot",
  NO_PROGRESSION_TEMPLATES_IN_SNAPSHOT: "noProgressionTemplatesInSnapshot",
  SNAPSHOT_NOT_FOUND_IN_EXPERIMENT_TEMPLATES: "snapshotNotFoundInExperimentTemplates",
  SNAPSHOT_NOT_FOUND_IN_PROGRESSION_TEMPLATES: "snapshotNotFoundInProgressionTemplates"
});
// Error prefix constants
__publicField(_ErrorInfoServiceInstance, "ERROR_PREFIXES", {
  GENERAL: "Error",
  AUTHENTICATION: "Authentication Error",
  NETWORK: "Network Error",
  VALIDATION: "Validation Error",
  SERVER: "Server Error",
  TIMEOUT: "Timeout Error",
  NOT_FOUND: "Not Found Error"
});
// Error messages
__publicField(_ErrorInfoServiceInstance, "ERROR_MESSAGES", {
  PROGRESSION_MODIFICATION: "This progression can no longer be modified, please try creating a new progression.",
  SELECT_TEMPLATE_AND_SNAPSHOT: "This will allow you to select an existing experiment template and snapshot.",
  SELECT_PROGRESSION_TEMPLATE_AND_SNAPSHOT: "This will allow you to select an existing progression template and snapshot.",
  SELECT_EXISTING_SNAPSHOT: "This will allow you to select an existing snapshot.",
  ISOLATION_GROUP_FIX: "To fix this error please try adding the isolation group(s) to the admin portal under FlightControl in the IsolationGroupsOwned field for this experimentation group. Then make an arbitrary change (e.g. add a flight you don't intend to use) to the feature and click save.  This will force the system to update the isolation group(s) in the feature."
});
// Regex patterns
__publicField(_ErrorInfoServiceInstance, "REGEX_PATTERNS", {
  ISOLATION_GROUP: /Isolation Group\(s\) \(([a-zA-Z0-9]+)\) could not be found\./,
  AUTHENTICATION: /unauthorized|forbidden|auth fail|not authorized|login|credential|permission denied/i,
  NETWORK: /network|connection|offline|unreachable|socket|connectivity/i,
  VALIDATION: /invalid|validation|required field|format|constraint/i,
  SERVER: /server|5\d\d error|internal error/i,
  TIMEOUT: /timeout|timed out|too long|slow/i,
  NOT_FOUND: /not found|404|missing|doesn't exist|could not find/i
});
let ErrorInfoServiceInstance = _ErrorInfoServiceInstance;
const ErrorInfoService = new ErrorInfoServiceInstance();
export {
  ErrorInfoService,
  ErrorInfoServiceInstance
};
//# sourceMappingURL=ErrorInfoService.js.map
